import {CodeBlockContentOptions} from './types';
import {defaultContentOptions} from '../constants';

export const DEFAULT_MODE: string = 'json';

export const MODE_OPTIONS: any = [
  {
    label: 'JSON',
    value: DEFAULT_MODE,
  },
  {
    label: 'Text',
    value: 'text',
  }
];

export const codeBlockContentOptions: CodeBlockContentOptions = {
  ...defaultContentOptions,
  showUploadCSV: true,
}
